@if (controller.isLibrary()) {
  <app-library-button additionalCssClass="white-background"></app-library-button>
}

<div class="reflections">


  @for (element of page.elements; track element) {
    @if (element.type == 'header') {
      <h1 [ngClass]="controller.getClassObject( element, [] )">{{element.value}}</h1>
    }
    @if (element.type == 'dash') {
      <div [ngClass]="controller.getClassObject( element, ['dash'] )"></div>
    }
    @if (element.type == 'p') {
      <p [ngClass]="controller.getClassObject( element, [] )" [innerHTML]="sanitizeHtml(element.value)"></p>
    }
    @if (element.type == 'hr') {
      <hr/>
    }
    @if (element.type == 'br') {
      <br />
    }
    @if (element.type == 'image') {
      <img [ngClass]="controller.getClassObject( element, [] )" [src]="getImageUrl(element.value)">
    }
    @if (element.type == 'ul') {
      <ul [ngClass]="controller.getClassObject( element, [] )">
        @for (el of element.elements; track el) {
          <li>{{el.value}}</li>
        }
      </ul>
    }
    <div class="buttons">
      @if (element.type == 'download-button' || element.type == 'reflection-button') {
        <button class="btn btn-outline-primary btn-outline submit-button hover active" (click)="viewReflection()">DOWNLOAD</button>
      }
    </div>
  }


</div>
